import React, { useEffect, useState } from "react";
import BulkMailForm from "./BulkMailForm";
import BulkMailHeader from "./BulkMailHeader";
import { useDispatch, useSelector } from "react-redux";
import { readUser } from "services/localStorage.service";
import { Avatar, Button, Card, Col, Drawer, Flex, Input, List, notification, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import type { RadioChangeEvent } from "antd";
import { addEventBulkMail } from "api/email.api";
import { UserOutlined } from "@ant-design/icons";
import { replaceReduxCandidates } from "store/slices/candidateBulkMail.slice";
import { useFeatureAllowedFromState } from "services/CustomeHooks";
import { FEATURE_CONSTANTS } from "components/constants/AppConstants";
import DrawerHeader from "components/CandidateCard/DrawerHeader";
import CandidateProfile from "components/CandidateProfile/CandidateProfile";
import { getCandidate } from "api/candidate.api";

interface BulkMailMainPageProps {
  onMailSent?: any;
  onSuccess?: any;
  emails?: any;
}

const BulkMailMainPage: React.FC<BulkMailMainPageProps> = ({ onMailSent, onSuccess, emails }: any) => {
  const talentPool = useSelector((state: any) => state.candidateBulkMail.talentPool);
  const selectedCandidates = useSelector((state: any) => state.candidateBulkMail.candidates) || [];

  const [isShowCalenderLink, setIsShowCalenderLink] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [emailTemplateId, setEmailTemplateId] = useState<number | null>(null);
  const [isVideoBased, setIsVideoBased] = useState(true);
  const [subject, setSubject] = useState<{ candidateid: number; subject: string }[]>([]);
  const [selectedMails, setSelectedMails] = useState<any>([]);
  const [customSelectedMails, setCustomSelectedMails] = useState<any>([]);

  const [interviewMode, setInterviewMode] = useState<any>(null);
  const [questionId, setQuestionId] = useState(null);
  const [message, setMessage] = useState<{ candidateid: number; message: string }[]>([]);
  const [firstCandidateId, setFirstCandidateId] = useState<string | null>(null);
  const [selectedCcMails, setSelectedCcMails] = useState<any>([]);
  const user = readUser();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { projectId } = useParams();

  const [aiCandidateList, setAICandidateList] = useState<any>([]);
  const [selectedCandidateId, setSelectedCandidateId] = useState<any>(null);
  const [open, setOpen] = useState(false);

  const [searchQuery, setSearchQuery] = useState('');

  const isFeatureAllowed = useFeatureAllowedFromState(FEATURE_CONSTANTS.FCPV);

  const getMessageByCandidateId = (candidateId: number | null) => {
    return message.find((msg) => msg.candidateid === candidateId)?.message || null;
  };

  // const filteredCandidate = selectedCandidates.filter((item: any) => {
  //   const query = searchQuery.toLowerCase();
  //   return (
  //     item?.name?.toLowerCase().includes(query) ||
  //     item?.jobTitle?.toLowerCase().includes(query)
  //   );
  // });

  const filteredCandidate = Array.from(
    new Map(
      selectedCandidates
        .filter((item: any) => {
          const query = searchQuery.toLowerCase();
          return (
            item?.name?.toLowerCase().includes(query) ||
            item?.jobTitle?.toLowerCase().includes(query)
          );
        })
        .map((item: any) => [item.id, item]) // Use 'id' as the key
    ).values()
  );

  const handleSetMessage = (messageText: string) => {
    if (firstCandidateId) {

      setMessage((prevMessages) => {
        const existingIndex = prevMessages.findIndex(
          (msg) => msg.candidateid === Number(firstCandidateId)
        );

        if (existingIndex !== -1) {
          const updatedMessages = [...prevMessages];
          updatedMessages[existingIndex].message = messageText;
          return updatedMessages;
        }

        return [...prevMessages, { candidateid: Number(firstCandidateId), message: messageText }];
      });
    }
  };

  const getSubjectByCandidateId = (candidateId: number | null) => {
    return subject.find((msg) => msg.candidateid === candidateId)?.subject || "";
  };


  const handleSetSubject = (subjectText: string) => {
    if (firstCandidateId) {

      setSubject((prevSubjects) => {
        const existingIndex = prevSubjects.findIndex(
          (msg) => msg.candidateid === Number(firstCandidateId)
        );

        if (existingIndex !== -1) {
          const updatedSubject = [...prevSubjects];
          updatedSubject[existingIndex].subject = subjectText;
          return updatedSubject;
        }

        return [...prevSubjects, { candidateid: Number(firstCandidateId), subject: subjectText }];
      });
    }
  };



  const showDrawer = (id: number) => {
    if (isFeatureAllowed) {
      setSelectedCandidateId(id);
      setOpen(true);
    } else {
      notification.warning({
        message: "Warning",
        description: "Feature not available for in this plan.",
      });
    }
  };

  const onClose = () => {
    setOpen(false);
  };

  const handleCandidateRoute = async (candidateId: string) => {
    // Navigate to the candidate profile route with the candidateId
    navigate(`/candidate-details/${candidateId}`);
  };

  const getEmailByName = (email: string) => {
    const user = selectedCandidates.find((candidate: any) =>
      Array.isArray(candidate.email) ? candidate.email.includes(email) : candidate.email === email
    );
    return user ? user.graphProfileId : null;
  };

  const filteredCandidates = selectedCandidates.filter((candidate: any) =>
    Array.isArray(candidate.email)
      ? candidate.email.some((e: string) => selectedMails.includes(e))
      : selectedMails.includes(candidate.email)
  );


  useEffect(() => {
    let foundCandidateId: string | null = null;

    for (let i = 0; i < selectedMails.length; i++) {
      const candidateId = getEmailByName(selectedMails[i]);
      if (candidateId) {
        foundCandidateId = candidateId;
        break;
      }
    }

    if (foundCandidateId && !firstCandidateId) {
      console.log("First Candidate Id:", foundCandidateId);
      setFirstCandidateId(foundCandidateId);
    }
  }, [selectedMails]);



  function arrayToCommaSeparatedString(arr: string[]) {
    if (Array.isArray(arr)) {
      return arr.join(", ");
    }
    return "";
  }

  const cleanEmailInput = (email: any) => {
    // Handle array case
    if (Array.isArray(email)) {
      return email.map(email =>
        typeof email === 'string' && email.endsWith('*')
          ? email.slice(0, -1)
          : email
      );
    }

    // Handle single string case
    if (typeof email === 'string') {
      return email.endsWith('*') ? email.slice(0, -1) : email;
    }

    // Return as-is for other types
    return email;
  };

  const handleSendMail = async () => {
    if (interviewMode === "screening" && !questionId) {
      notification.error({
        message: "Validation Error",
        description: "Please select a question set for screening mode.",
      });
      return; // Stop execution if validation fails
    }
    setIsSending(true);

    const recipient_details = filteredCandidates.map((candidate: any, index: number) => {
      const validEmails = Array.isArray(candidate.email)
        ? candidate.email.filter((email: string) => selectedMails.includes(email))
        : selectedMails.includes(candidate.email)
          ? [candidate.email]
          : [];

      return validEmails.length > 0
        ? {
          id: candidate.id,
          graph_profile_id: candidate.graphProfileId,
          name: candidate.name,
          emails: [...cleanEmailInput(validEmails), ...cleanEmailInput(customSelectedMails)],
          cc_emails: selectedCcMails,
          email_subject: getSubjectByCandidateId(Number(candidate.graphProfileId)),
          email_body: getMessageByCandidateId(Number(candidate.graphProfileId)),
        }
        : null;
    }).filter(Boolean);

    console.log("Recipient Details: ", recipient_details);
    if (recipient_details.length > 0) {
      try {
        const emailPayload = {
          template_id: emailTemplateId,
          add_calender_link: interviewMode !== "screening" && isShowCalenderLink,
          recipient_details,
          ...(interviewMode === "screening" ? { question_set: questionId } : {}),
          add_screening_interview: interviewMode === "screening",
          video_based: isVideoBased && interviewMode === "screening",
          project_id: talentPool,
        };
        const res = await addEventBulkMail(emailPayload);
        if (res) {
          setSelectedMails([]);
          setSubject([]);
          setMessage([]);
          notification.success({
            message: "Email sent successfully",
            description:
              arrayToCommaSeparatedString(selectedMails) + " - " + "email sent successfully",
          });
          onMailSent && onMailSent();
          onSuccess && onSuccess();
          // dispatch(replaceReduxCandidates([]));
          // navigate("/talent-pools");
          // history.back();
        }
      } catch (error: any) {
        notification.error({
          message: "Error",
          description: error?.message ?? "Failed to send email",
        });
      } finally {
        setIsSending(false);
      }
    }
  };

  useEffect(() => {
    if (selectedCandidates.length === 0) {
      notification.warning({
        message: "No candidates were selected",
        description: "Please select candidates",
      });
      navigate("/talent-pools");
    }
    console.log("Selected Candidates: ", selectedCandidates);
  }, [selectedCandidates]);

  const handleVideoBasedChange = (e: RadioChangeEvent) => {
    setIsVideoBased(e.target.value);
  };
  return (
    <div>
      <Row gutter={16} style={{ padding: "24px" }} className="w-full">
        {/* Left Sidebar - AI Suggested */}
        <Col
          xs={24}
          sm={24}
          md={10}
          lg={8}
          xl={6}
        // className="p-4"
        >
          <Card title="Selected Candidates">
            <Input
              placeholder="Search candidates"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{ marginBottom: 16, width: '100%' }}
              prefix={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    d="M17.5 17.5L14.5834 14.5833M16.6667 9.58333C16.6667 13.4954 13.4954 16.6667 9.58333 16.6667C5.67132 16.6667 2.5 13.4954 2.5 9.58333C2.5 5.67132 5.67132 2.5 9.58333 2.5C13.4954 2.5 16.6667 5.67132 16.6667 9.58333Z"
                    stroke="#667085"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              }
              rootClassName="py-[4px] px-[14px] rounded-lg bg-bg-secondary w-[260px]"
            />
            <div style={{ maxHeight: '700px', overflowY: 'auto' }} className="scrollbar-thin">
              <List
                itemLayout="horizontal"
                dataSource={filteredCandidate}
                renderItem={(item: any) => {
                  const isSelected = firstCandidateId === item.graphProfileId;
                  return (
                    <List.Item
                      onClick={() => {
                        if (item?.email) {
                          const validEmails = item.email.filter((email: any) => email !== null);
                          // setSelectedMails(validEmails);
                          setFirstCandidateId(item.graphProfileId);
                        }
                      }}
                      className={`rounded cursor-pointer transition-colors duration-300 
            ${isSelected ? 'bg-blue-100' : 'hover:bg-gray-100'}
          `}
                    >
                      <List.Item.Meta
                        avatar={
                          <Avatar
                            size={40}
                            icon={
                              item?.profile ? (
                                <img
                                  src={item?.profile}
                                  alt="Profile"
                                  onClick={() => handleCandidateRoute(item.id)}
                                />
                              ) : (
                                <UserOutlined onClick={() => handleCandidateRoute(item.id)} />
                              )
                            }
                          />
                        }
                        title={
                          <div className="cursor-pointer" onClick={() => console.log(item.id)}>
                            {item?.name}
                          </div>
                        }
                        style={{ paddingLeft: 15, paddingRight: 15 }}
                        description={item?.jobTitle}
                      />
                    </List.Item>
                  );
                }}
              />
            </div>


            {/* </Spin> */}
          </Card>
        </Col>

        {/* Main Content */}
        <Col
          xs={24}
          sm={24}
          md={14}
          lg={16}
          xl={18}
        // className="p-4"
        >
          <BulkMailHeader
            handleSendMail={handleSendMail}
            isSending={isSending}
            candidates={selectedCandidates}
            selectedMails={selectedMails}
          />

          <div className="py-4">
            <div className="p-6 bg-white">
              <BulkMailForm
                subject={getSubjectByCandidateId(Number(firstCandidateId))}
                setSubject={handleSetSubject}
                message={getMessageByCandidateId(Number(firstCandidateId))}
                setMessage={handleSetMessage}
                selectedMails={selectedMails}
                setEmailTemplateId={setEmailTemplateId}
                setSelectedMails={setSelectedMails}
                setFirstCandidateId={setFirstCandidateId}
                isShowCalenderLink={isShowCalenderLink}
                setIsShowCalenderLink={setIsShowCalenderLink}
                interviewMode={interviewMode}
                setInterviewMode={setInterviewMode}
                questionId={questionId}
                setQuestionId={setQuestionId}
                isVideoBased={isVideoBased}
                handleVideoBasedChange={handleVideoBasedChange}
                profileId={firstCandidateId}
                emails={emails}
                selectedCcMails={selectedCcMails}
                setSelectedCcMails={setSelectedCcMails}
                setCustomSelectedMails={setCustomSelectedMails}
                customSelectedMails={customSelectedMails}
                handleSendMail={handleSendMail}
                isSending={isSending}
              />
            </div>
          </div>
        </Col>
        {isFeatureAllowed && <Drawer
          placement="right"
          width="50%"
          onClose={onClose}
          open={open}
          extra={
            <DrawerHeader
              candidateId={selectedCandidateId}
              selectedPool={projectId}
            />
          }
        >
          <CandidateProfile open={open} clickedProfile={selectedCandidateId} />
        </Drawer>}
      </Row>
    </div>
  );
};

export default BulkMailMainPage;
